import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const stats = [
  { value: '42', suffix: '+', label: 'Processing Centers' },
  { value: '18,000', suffix: '+', label: 'Tonnes Processed/Year' },
  { value: '99.2', suffix: '%', label: 'SKU Conformance Rate' },
];

export default function ProcessingHero() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="relative w-full overflow-hidden bg-brand-700">
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.3'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-br from-brand-800/90 via-brand-700/80 to-brand-600/60"></div>
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-brand-700 to-transparent"></div>

      <div className="absolute right-0 top-0 w-1/2 h-full hidden lg:block">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-transparent to-brand-700/60"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20food%20processing%20facility%20interior%20with%20stainless%20steel%20conveyor%20tables%20and%20vacuum%20packaging%20machines%2C%20clean%20sterile%20industrial%20environment%2C%20cool%20white%20ambient%20lighting%2C%20brushed%20metal%20surfaces%2C%20no%20people%2C%20corporate%20infrastructure%20photography%20style%2C%20high%20contrast%20dramatic%20lighting%20on%20steel%20surfaces%2C%20pristine%20hygienic%20aesthetic&width=900&height=800&seq=freshhlock-processing-hero-01&orientation=portrait"
          alt="Food processing facility"
          className="w-full h-full object-cover opacity-25"
        />
      </div>

      <div ref={ref} className={`container-page relative z-10 scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="flex flex-col lg:flex-row items-center min-h-[600px] md:min-h-[680px] py-16 md:py-24">
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-600/50 border border-brand-500/30 mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-400"></div>
              <span className="text-xs font-medium text-brand-200 uppercase tracking-widest">
                Value-Added Processing Network
              </span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-paper-50 leading-tight mb-6 text-balance">
              From Harvest to
              <br />
              <span className="text-accent-400">Standardised SKU</span>, Ready to Trade
            </h1>

            <p className="text-base md:text-lg text-brand-100/80 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              Freshhlock Processing transforms raw harvest into trade-ready frozen products — cleaning, grading, weighing, vacuum packing, and standardising every batch to spec before it enters the cold chain.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/contact"
                className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all hover:scale-[1.02] text-center whitespace-nowrap cursor-pointer"
              >
                Enquire About Processing
              </Link>
              <a
                href="#services"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-paper-300/30 hover:border-paper-50/50 text-paper-50 font-semibold text-sm rounded-lg transition-all hover:bg-paper-50/5 text-center whitespace-nowrap cursor-pointer"
              >
                Explore Services
              </a>
            </div>
          </div>

          <div className="hidden lg:block w-2/5"></div>
        </div>

        <div className="pb-10 md:pb-14">
          <div className="flex flex-wrap items-center justify-center lg:justify-start gap-8 md:gap-14">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading text-3xl md:text-4xl font-bold text-accent-400 tabular-nums">
                  {stat.value}{stat.suffix}
                </div>
                <div className="text-xs md:text-sm text-brand-200/70 mt-1 uppercase tracking-wider">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}